<div class="table-container mark" [ngStyle]="getContainerStyle(reportVisualEvents)" (click)="onClick($event)" [ngClass]="{
    'dynamic-mark': true,
    'selectable': reportVisualEvents.isSelectable,
    'selected': reportVisualEvents.isSelected,
    'edited': !reportVisualEvents.isSaved() }">
  <div style="height: 9mm; padding: 0 5mm; font-weight:bold" [style.font-size]="reportVisualEvents.titleFontSize" [style.text-align]="reportVisualEvents.titleAlign"
         [style.background-color]="reportVisualEvents.titleBackgroundColor">{{reportVisualEvents.titleText}}</div>
  <div class="my-2">
    <span>**Configure visual events item grid**</span>
  </div>

  <div [ngStyle]="getStyles(reportVisualEvents)">
    <img alt="visual item">
  </div>
  <div style="height: 9mm;" *ngFor="let caption of reportVisualEvents.captionsList">
    <span style="padding: 0 0.5rem"><b>{{caption.label}}</b></span>
    <span style="padding: 0 0.5rem" *ngIf="caption.type === 'Dynamic'">{{ '{'+caption.dataField+'}' }}</span>
    <span style="padding: 0 0.5rem" *ngIf="caption.type === 'Editable'">[Editable Text]</span>
  </div>

</div>
